import React from 'react';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { CustomerListTabScreen } from './TabScreens/List';

export { CustomerFormRoute } from './CustomerFormRoute';

export function CustomersPage() {
  useDocumentTitle(appDocumentTitle('Customer'));

  return (
    <PageShell title="Customer">
      <CustomerListTabScreen />
    </PageShell>
  );
}
